import classNames from 'classnames';
import { CSSProperties } from 'react';

import SVG from '../SVG/SVG';

import styles from './IconInCircle.module.css';

const getOffsetStyle = (x?: number, y?: number): CSSProperties => {
    if (!x && !y) {
        return {};
    }

    const style: CSSProperties = {};
    if (x) {
        style.marginLeft = `${x}px`;
    }

    if (y) {
        style.marginTop = `${y}px`;
    }

    return style;
};

type IconInCircleProps = {
    src: string;
    className?: string;
    size?: 'small' | 'medium' | 'large' | 'large-plus' | 'xlarge' | 'xxlarge';
    variant?:
        | 'subtle'
        | 'default'
        | 'accent'
        | 'brand'
        | 'error'
        | 'success'
        | 'white'
        | 'black-blended';
    shadow?: boolean;
    offsetX?: number;
    offsetY?: number;
};

const IconInCircle = ({
    src,
    className,
    offsetX,
    offsetY,
    shadow = false,
    variant = 'default',
    size = 'medium',
}: IconInCircleProps) => {
    const classes = classNames(className, styles.Root, {
        [styles.styleDefault]: variant === 'default',
        [styles.styleWhite]: variant === 'white',
        [styles.styleAccent]: variant === 'accent',
        [styles.styleSubtle]: variant === 'subtle',
        [styles.styleBrand]: variant === 'brand',
        [styles.styleError]: variant === 'error',
        [styles.styleSuccess]: variant === 'success',
        [styles.styleBlackBlended]: variant === 'black-blended',
        [styles.sizeSmall]: size === 'small',
        [styles.sizeMedium]: size === 'medium',
        [styles.sizeLarge]: size === 'large',
        [styles.sizeLargePlus]: size === 'large-plus',
        [styles.sizeXLarge]: size === 'xlarge',
        [styles.sizeXXLarge]: size === 'xxlarge',
        [styles.shadow]: shadow,
    });

    return (
        <span className={classes}>
            <SVG
                src={src}
                className={styles.Icon}
                style={getOffsetStyle(offsetX, offsetY)}
            />
        </span>
    );
};

export default IconInCircle;
